import { render, staticRenderFns } from "./ListMyAuthorsTasks.vue?vue&type=template&id=ad97c8c8&"
import script from "./ListMyAuthorsTasks.vue?vue&type=script&lang=js&"
export * from "./ListMyAuthorsTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports